import { getTimeZones } from "@vvo/tzdb";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DropDownRemoteSearch } from "./DropDownRemoteSearch";
import { TestIDs } from "../tests/types/testIds";

type Props = {
  value?: string;
  onChange: (value: string) => void;
  error?: any;
  info?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
};

export const TimezonePicker: React.FC<Props> = ({
  value,
  onChange,
  error,
  info,
  className,
  disabled,
  required,
}) => {
  const { t } = useTranslation();
  const timezones = getTimeZones({ includeUtc: true });

  const tzOptions = useMemo(() => {
    return timezones.map((tz) => ({
      label: `${tz.countryName} - ${tz.name} (UTC ${tz.currentTimeFormat.slice(0, 6)})`,
      value: tz.name,
      "data-testid":
        TestIDs.general.settings.initialPreferencesModal.timezone.option(
          tz.name,
        ),
    }));
  }, [timezones]);

  const onSearchTimezones = useCallback(
    async (keyword: string) => {
      return timezones
        .filter(
          (tz) =>
            tz.name.toLowerCase().includes(keyword.toLowerCase()) ||
            tz.countryName.toLowerCase().includes(keyword.toLowerCase()),
        )
        .map((tz) => ({
          label: `${tz.countryName} - ${tz.name} (UTC ${tz.currentTimeFormat.slice(0, 6)})`,
          value: tz.name,
          "data-testid":
            TestIDs.general.settings.initialPreferencesModal.timezone.option(
              tz.name,
            ),
        }));
    },

    [timezones],
  );

  return (
    <DropDownRemoteSearch
      title={t("settings.general.timezone.title")}
      defaultOptions={tzOptions}
      fetchOptions={onSearchTimezones}
      value={value as any}
      onChange={onChange}
      info={info}
      valid={!error}
      errorMessage={error?.message}
      className={className}
      disabled={disabled}
      required={required}
    />
  );
};
